export function setBanlistpgsLoading (state, loading = false) {
  state.banlistpgsLoading = loading
}

export function setTodayLimitsLoading (state, loading = false) {
  state.todaylimitsLoading = loading
}

export function setBanlistpgs (state, banlistpgs) {
  state.banlistpgs = banlistpgs.data
  state.banlistpgsCurrentPage = banlistpgs.current_page
  state.banlistpgsLastPage = banlistpgs.last_page
  state.banlistpgsPerPage = banlistpgs.per_page
  state.banlistpgsTotal = banlistpgs.total
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
